export var TypeActionBaseInfo;
(function (TypeActionBaseInfo) {
    TypeActionBaseInfo["Received"] = "BaseInfo > Received";
    TypeActionBaseInfo["AddBuilding"] = "BaseInfo > AddBuilding";
    TypeActionBaseInfo["UpdateBuilding"] = "BaseInfo > UpdateBuilding";
    TypeActionBaseInfo["RemoveBuilding"] = "BaseInfo > RemoveBuilding";
    TypeActionBaseInfo["FinishConstruction"] = "BaseInfo > FinishConstruction";
    TypeActionBaseInfo["AddExpansion"] = "BaseInfo > AddExpansion";
})(TypeActionBaseInfo || (TypeActionBaseInfo = {}));
export var actionBaseInfo = function (baseInfo) { return ({
    baseInfo: baseInfo,
    type: TypeActionBaseInfo.Received,
}); };
export var actionBaseInfoAddBuilding = function (building) { return ({
    building: building,
    type: TypeActionBaseInfo.AddBuilding,
}); };
export var actionBaseInfoRemoveBuilding = function (building) { return ({
    building: building,
    type: TypeActionBaseInfo.RemoveBuilding,
}); };
export var actionBaseInfoUpdateBuilding = function (building) { return ({
    building: building,
    type: TypeActionBaseInfo.UpdateBuilding,
}); };
export var actionBaseInfoFinishConstruction = function (building) { return ({
    building: building,
    type: TypeActionBaseInfo.FinishConstruction,
}); };
export var actionBaseInfoAddExpansion = function (expansionId) { return ({
    expansionId: expansionId,
    type: TypeActionBaseInfo.AddExpansion,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/base/actionBaseInfo.ts
// module id = 127
// module chunks = 3